import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Contact } from '../models/contact';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(
    private _http: HttpClient
  ) {}

  public sendMessage(message:Contact): Observable<any>{
    return this._http.post(environment.apiEndpoint + '/api/contact', {message: message}).pipe(
      map(
        res => {
          return res;
        }
      )
    );
  }
}
